"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  list-style: none;\n  padding-left: 21px;\n  margin: 0;\n"], ["\n  list-style: none;\n  padding-left: 21px;\n  margin: 0;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: 4px;\n  padding-left: 4px;\n"], ["\n  position: relative;\n  padding-bottom: 4px;\n  padding-left: 4px;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 9px;\n  left: -21px;\n"], ["\n  position: absolute;\n  top: 9px;\n  left: -21px;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyIcons = require("buoy-icons");

var _Ul = require("./Ul");

var _Ul2 = _interopRequireDefault(_Ul);

var _Li = require("./Li");

var _Li2 = _interopRequireDefault(_Li);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ChecklistUl = (0, _styledComponents2.default)(_Ul2.default).withConfig({
  displayName: "Checklist__ChecklistUl",
  componentId: "sc-5h1xwn-0"
})(_templateObject);

var ChecklistLi = (0, _styledComponents2.default)(_Li2.default).withConfig({
  displayName: "Checklist__ChecklistLi",
  componentId: "sc-5h1xwn-1"
})(_templateObject2);

var Check = _styledComponents2.default.div.withConfig({
  displayName: "Checklist__Check",
  componentId: "sc-5h1xwn-2"
})(_templateObject3);

var Checklist = function Checklist(_ref) {
  var items = _ref.items,
      color = _ref.color;
  return _react2.default.createElement(
    ChecklistUl,
    null,
    items.map(function (item, i) {
      return _react2.default.createElement(
        ChecklistLi,
        { key: item + "_" + i },
        _react2.default.createElement(
          Check,
          null,
          _react2.default.createElement(_buoyIcons.CheckIcon, { color: color })
        ),
        item
      );
    })
  );
};

Checklist.propTypes = {
  items: _propTypes2.default.array.isRequired,
  color: _propTypes2.default.string
};

Checklist.defaultProps = {
  color: "primary"
};

exports.default = Checklist;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-list/dist/components/Checklist.js
// module id = 428
// module chunks = 168707334958949